import '../../styles/AthleteCard.css';

import React from 'react';

import { Card } from './index';

export default function AthleteCardShimmer() {
  return (
    <Card className="athlete-card">
      <div className="athlete-image">
        <div className="shimmer shimmer-photo"></div>
      </div>
      <div className="athlete-card-rightside"> 
        <div className="athlete-info">
          <div className="shimmer shimmer-text medium"></div>
          <div className="shimmer shimmer-text short"></div>
          <div className="shimmer shimmer-text short"></div>
          <div className="shimmer shimmer-text medium"></div>
        </div>
      </div>
    </Card>
  );
} 